import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { ZendeskCategories, ZendeskSubCategories } from './ZendeskCategories';
import PlayerInterface from '../../api/PlayerInterface';
import { getText, TEXT_KEY } from '../../utils/localization';

var ChangePasswordForm = require('../../assets/star/forms/changePassword.form');

var ChangePassword = /*#__PURE__*/function (_Component) {
  _inherits(ChangePassword, _Component);

  var _super = _createSuper(ChangePassword);

  function ChangePassword(props) {
    var _this;

    _classCallCheck(this, ChangePassword);

    _this = _super.call(this, props);

    _this.initForm = function () {
      var category = ZendeskCategories[0].value;
      ChangePasswordForm.steps[0].formInputList[0].options = ZendeskCategories;
      ChangePasswordForm.steps[0].formInputList[1].options = ZendeskSubCategories[category];
      ChangePasswordForm.steps[0].formInputList[0].label = getText(TEXT_KEY.CURRENT_PASSWORD);
      ChangePasswordForm.steps[0].formInputList[1].label = getText(TEXT_KEY.NEW_PASSWORD);
      ChangePasswordForm.steps[0].formInputList[2].label = getText(TEXT_KEY.CONFIRM_PASSWORD);
      ChangePasswordForm.steps[0].submitButtonText = getText(TEXT_KEY.UPDATE_PASS_BUTTON);

      _this.setState({
        layout: ChangePasswordForm
      });
    };

    _this._changePassword = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(handleResponse) {
        var formInfo, body, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formInfo = _this.props.formInfo;

                if (!(!formInfo.password_old.validated && !formInfo.password_new.validated)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!(formInfo.password_new.value !== formInfo.password_new_confirm.value)) {
                  _context.next = 8;
                  break;
                }

                _this.setState({
                  responseSuccess: false,
                  messageResponse: getText(TEXT_KEY.PASSWORDS_DONT_MATCH)
                });

                return _context.abrupt("return");

              case 8:
                if (_this.state.responseSuccess != null) {
                  _this.setState({
                    messageResponse: '',
                    responseSuccess: null
                  });
                }

              case 9:
                body = {
                  newPassword: formInfo.password_new.value,
                  oldPassword: formInfo.password_old.value
                };
                _context.prev = 10;
                _context.next = 13;
                return PlayerInterface.changePassword(body);

              case 13:
                response = _context.sent;

                if (!(response && response.success)) {
                  _context.next = 19;
                  break;
                }

                !!handleResponse && handleResponse(true);

                _this.setState({
                  responseSuccess: true,
                  messageResponse: getText(TEXT_KEY.PASSWORD_SUCCESSFULLY_CHANGED)
                });

                _context.next = 22;
                break;

              case 19:
                !!handleResponse && handleResponse(false);

                _this.setState({
                  responseSuccess: false,
                  messageResponse: response.error
                });

                throw response.error;

              case 22:
                _context.next = 29;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](10);
                !!handleResponse && handleResponse(false);
                console.log('Zendesk Error: ', _context.t0);

                _this.setState({
                  responseSuccess: false,
                  messageResponse: _context.t0
                });

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 24]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      layout: ChangePasswordForm,
      messageResponse: '',
      responseSuccess: null
    };
    return _this;
  }

  _createClass(ChangePassword, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initForm();
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      var _this$state = this.state,
          layout = _this$state.layout,
          messageResponse = _this$state.messageResponse,
          responseSuccess = _this$state.responseSuccess;
      return render({
        layout: layout,
        changePassword: this._changePassword,
        messageResponse: messageResponse,
        responseSuccess: responseSuccess
      });
    }
  }]);

  return ChangePassword;
}(Component);

export { ChangePassword as default };